import { Injectable } from '@angular/core';

@Injectable()
export class GlobalsVariables {
  meta: {} = {
    startseite: {title: '', description: 'Chris Wehrmann'}
    , contact: {title: 'Kontakt', description: 'Kontakt Chris Wehrmann'}
    , imprint: {title: 'Impressum', description: 'Impressum'}
    , dataprivacy: {title: 'Datenschutz', description: 'Datenschutz'}


    , aholyfamily: {title: 'a holy family', description: 'a holy family'}
    , virtualnatures: {title: 'virtual natures', description: 'New technologies = new means of sketching.'}
    , benotafeard: {title: 'be not afeard', description: 'be not afeard'}
    , linieleerelicht: {title: 'linie leere licht', description: 'linie leere licht'}
    , frozenmomentsfamiliar: {title: 'frozen moments familiar', description: 'frozen moments familiar'}
    , abandonedspaces: {title: 'abandoned spaces', description: 'abandoned spaces'}
    , childsplay: {title: 'child\'s play', description: 'child\'s play'}
    , vita: {title: 'vita', description: 'vita'}
    , perception_deception: {title: 'PERception_DEception', description: 'PERception_DEception'}
  };
  private _showLayer = false;
  public get showLayer(): boolean {
    return this._showLayer;
  }
  public set showLayer(value: boolean) {
    this._showLayer = value;
  }

}
